import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './Preloader.scss';

const normalizeCssColor = (value) => {
  const rawColor = typeof value === 'object'
    ? value?.rgb || value?.hex || value?.value
    : value;

  if (!rawColor) return null;

  const color = String(rawColor).trim();

  if (/^(#|rgb|hsl|var\()/i.test(color)) {
    return color;
  }

  if (/^\d+\s*,\s*\d+\s*,\s*\d+/.test(color)) {
    return `rgb(${color})`;
  }

  return color;
};

const setThemeColor = (name, colorData) => {
  const color = normalizeCssColor(colorData);
  if (color) {
    document.documentElement.style.setProperty(name, color);
  } else {
    document.documentElement.style.removeProperty(name);
  }
};

const themeColorFields = [
  ['--color-base', ['colorPrin', 'color_prin', 'color1']],
  ['--color-base-hover', ['colorSec', 'color_sec', 'color2']],
  ['--color-text', ['colorText', 'color_text']],
  ['--color-text-selected', ['colorTextSelected', 'color_text_selected']],
  ['--color-title', ['colorTitle', 'color_title']],
  ['--color-nav2', ['colorNav2', 'color_nav2']],
  ['--color-nav-text2', ['colorNavText2', 'color_nav_text2']],
  ['--color-price', ['colorPriceText', 'color_price_text']],
  ['--color-button', ['colorButton', 'color_button']],
  ['--color-button-text', ['colorButtonText', 'color_button_text']],
  ['--brand-footer-bg', ['colorFooterBackground', 'color_footer_background']],
  ['--brand-footer-title', ['colorFooterTitle', 'color_footer_title']],
  ['--brand-footer-text', ['colorFooterText', 'color_footer_text']],
  ['--brand-footer-bottom-bg', ['colorFooterBottom', 'color_footer_bottom']],
];

const resolveColor = (client, fields) => {
  for (const field of fields) {
    const value = client?.[field];
    if (value && typeof value === 'object') return value;
  }
  for (const field of fields) {
    const value = client?.[field];
    // Foreign-key IDs are not CSS colors; don't accidentally write "12" into CSS.
    if (typeof value === 'string' && /^(#|rgb|hsl|var\(|\d{1,3}\s*,)/i.test(value.trim())) return value;
  }
  return null;
};

const Preloader = (props) => {
  const { showPreloader,client } = props;
  useEffect(() => {
    document.body.style.overflow = (showPreloader) ? 'hidden' : 'auto';
  }, [showPreloader]);

  useEffect(() => {
    themeColorFields.forEach(([cssVariable, clientFields]) => {
      setThemeColor(cssVariable, resolveColor(client, clientFields));
    });
  }, [client]);

  return (
    <div className={`preloader ${(showPreloader) ? '' : 'hide'}`} data-testid="preloader">
      {showPreloader &&
        <div className="preloader-content-container" role="status" aria-live="polite">
          <div className="store-loader" aria-hidden="true">
            <svg className="store-loader__graphic" viewBox="0 0 64 64" focusable="false">
              <circle className="store-loader__track" cx="32" cy="32" r="27" />
              <circle className="store-loader__progress" cx="32" cy="32" r="27" />
              <path className="store-loader__bag" d="M22 27h20l-2 21H24l-2-21Z" />
              <path className="store-loader__handle" d="M27 28v-4a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <span className="store-loader__label">Estamos preparando todo para vos</span>
        </div>
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  showPreloader: state.app.showPreloader,
  client: state.app.client,
});

Preloader.propTypes = {
  showPreloader: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Preloader);
